import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function MetaAuthRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");
    const from = urlParams.get("state");
    const error = urlParams.get("error");
    if (code && from) {
      window.location.href = `${from}?code=${code}&streamStage=1`;
    } else if (error === "access_denied") {
      window.location.href = `${from}`;
    }
  }, [navigate, location]);

  // While the redirect is being processed you can show a loading screen
  return <div>Loading...</div>;
}

export default MetaAuthRedirect;
